import { motion } from 'framer-motion'
import { Save } from 'lucide-react'

export default function Settings() {
  return (
    <div className="w-full min-w-0 max-w-full">
      <div className="mb-8">
        <h1 className="font-serif text-4xl md:text-5xl font-light text-white mb-2">
          Einstellungen
        </h1>
        <div className="h-px w-24 bg-gradient-to-r from-brand-500 to-brand-500" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative bg-gradient-to-br from-gray-900/80 to-gray-900/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/10 p-6 space-y-6 overflow-hidden"
      >
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent pointer-events-none" />
        
        <div className="relative z-10">
          <div>
            <h2 className="font-serif text-2xl md:text-3xl font-light text-white mb-4">
              Allgemeine Einstellungen
            </h2>
            <div className="h-px w-16 bg-gradient-to-r from-brand-500 to-brand-500 mb-6" />
            
            <div className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Website-Name
                </label>
                <input
                  type="text"
                  defaultValue="Hückels May"
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:ring-2 focus:ring-brand-500/50 focus:border-brand-500/50 transition-all duration-300 outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  E-Mail
                </label>
                <input
                  type="email"
                  defaultValue="info@hueckels-may.de"
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:ring-2 focus:ring-brand-500/50 focus:border-brand-500/50 transition-all duration-300 outline-none"
                />
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-white/10">
            <motion.button 
              className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-brand-600 to-brand-600 border border-brand-500/30 text-white rounded-xl hover:from-brand-500 hover:to-brand-500 transition-all duration-300 shadow-lg shadow-brand-600/20"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Save className="h-5 w-5" />
              Speichern
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

















